module.exports = __webpack_public_path__ + "img/icon-just.1f64beac.svg";